/**
 * TDS · PUENTE TEMPORAL: lo recién añadido, arriba del carrito lateral.
 *
 * El cajón lo pinta la app Carrito Lateral en el orden en que Shopify
 * devuelve las líneas, que es por antigüedad: lo que el cliente acaba de
 * añadir cae al final y, con el carrito lleno, ni se ve. La app ya lleva el
 * arreglo, pero hasta que se publique (`shopify app deploy --config
 * carrito-lateral`) la tienda sigue sirviendo la versión anterior.
 *
 * Esto hace lo mismo desde el tema: escucha las llamadas a /cart/add.js para
 * saber QUÉ se acaba de añadir y reordena las líneas del cajón — lo último
 * primero y el resto del más nuevo al más viejo. Solo mueve nodos ya
 * pintados, así que los botones de cantidad y de quitar siguen funcionando
 * (mover un nodo conserva sus eventos).
 *
 * Se borra junto con su snippet en cuanto se publique la app.
 *
 * Sin console.log.
 */
(function () {
  'use strict';

  var CUERPO = '[data-cd-cuerpo]';
  var LINEA = '.cd-linea';
  var MEMORIA = 'tds:ultimo-add';

  var ultimo = null;
  try { ultimo = sessionStorage.getItem(MEMORIA); } catch (e) { /* modo privado */ }

  var cache = null;
  var cacheEn = 0;

  /** Guarda la línea que acaba de crear /cart/add.js. */
  function recordar(j) {
    var linea = j && j.items && j.items.length ? j.items[j.items.length - 1] : j;
    var clave = linea && (linea.key || linea.id);
    if (!clave) return;
    ultimo = String(clave);
    try { sessionStorage.setItem(MEMORIA, ultimo); } catch (e) { /* modo privado */ }
    cache = null;              // el carrito ha cambiado
    programar();
  }

  var fetchOriginal = window.fetch;
  window.fetch = function (url) {
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    var p = fetchOriginal.apply(this, arguments);
    if (u.indexOf('/cart/add') !== -1) {
      p.then(function (r) {
        if (!r || !r.ok || !r.clone) return;
        try { r.clone().json().then(recordar).catch(function () {}); } catch (e) { /* ya consumida */ }
      }).catch(function () {});
    }
    return p;
  };

  var abrirXHR = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  if (abrirXHR) {
    window.XMLHttpRequest.prototype.open = function (metodo, url) {
      if (String(url || '').indexOf('/cart/add') !== -1) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          try { recordar(JSON.parse(this.responseText)); } catch (e) { /* no era JSON */ }
        });
      }
      return abrirXHR.apply(this, arguments);
    };
  }

  /**
   * Lo que el panel ofrece como añadido (complementos, recomendados y lo que
   * ofrece cada regla). Con esa lista se sabe qué línea es un extra —el
   * servicio de rediseño, el soporte, las tiras— y cuál es la compra.
   */
  var extras = null;
  function listaExtras() {
    if (extras) return Promise.resolve(extras);
    return fetchOriginal.call(window, '/apps/carrito/config', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var a = (j && j.ajustes) || {};
        var set = {};
        var mete = function (lista) {
          (lista || []).forEach(function (u) {
            var h = typeof u === 'string' ? u : (u && u.handle) || '';
            if (h) set[h] = true;
          });
        };
        mete(a.upsells);
        var rec = a.recomendados || {};
        mete(rec.productos);
        (rec.reglas || []).forEach(function (r2) { mete(r2 && r2.ofrece); });
        extras = set;
        return extras;
      })
      .catch(function () { extras = {}; return extras; });
  }

  /** Una línea con foto, dedicatoria o medidas es la compra, no un extra. */
  function llevaPersonalizacion(it) {
    var props = it && it.properties;
    if (!props) return false;
    for (var k in props) {
      if (Object.prototype.hasOwnProperty.call(props, k) && props[k] !== '' && props[k] != null) return true;
    }
    return false;
  }

  var enVuelo = null;
  function carrito() {
    if (enVuelo) return enVuelo;          // una sola petición a la vez
    if (cache && Date.now() - cacheEn < 3000) return Promise.resolve(cache);
    enVuelo = fetchOriginal.call(window, '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { cache = j; cacheEn = Date.now(); enVuelo = null; return j; })
      .catch(function (e) { enVuelo = null; throw e; });
    return enVuelo;
  }

  /** La clave de línea la llevan los botones de cantidad y de quitar. */
  function claveDe(nodo) {
    var b = nodo.querySelector('[data-cd-mas], [data-cd-menos], [data-cd-quitar]');
    if (!b) return '';
    return b.getAttribute('data-cd-mas') || b.getAttribute('data-cd-menos') ||
      b.getAttribute('data-cd-quitar') || '';
  }

  function ordenar() {
    var cuerpo = document.querySelector(CUERPO);
    if (!cuerpo) return;
    var lineas = [].slice.call(cuerpo.querySelectorAll(LINEA));
    if (lineas.length < 2) return;

    Promise.all([carrito(), listaExtras()]).then(function (res) {
      var c = res[0];
      var esExtras = res[1] || {};
      // Primero lo que se ha venido a comprar (cuadro, lámpara, reloj) y
      // debajo los añadidos, que se meten después y acababan tapándolo.
      // Dentro de cada grupo, del más nuevo al más viejo; y lo último
      // añadido del todo arriba, pero solo si es una compra: si el producto
      // ya estaba, Shopify solo le sube la cantidad y no lo mueve de sitio.
      var compras = [];
      var anadidos = [];
      ((c && c.items) || []).slice().reverse().forEach(function (i) {
        var ficha = { key: String(i.key), id: String(i.id) };
        if (esExtras[i.handle] && !llevaPersonalizacion(i)) anadidos.push(ficha);
        else compras.push(ficha);
      });
      if (ultimo) {
        for (var n = 0; n < compras.length; n++) {
          if (compras[n].key === ultimo || compras[n].id === ultimo) {
            if (n > 0) compras.unshift(compras.splice(n, 1)[0]);
            break;
          }
        }
      }
      var orden = compras.concat(anadidos);

      var porClave = {};
      lineas.forEach(function (l) {
        var k = claveDe(l);
        if (k) porClave[k] = l;
      });

      var deseado = orden.map(function (o) { return o.key; })
        .filter(function (k) { return porClave[k]; });
      var actual = lineas.map(claveDe).filter(Boolean);
      if (actual.join('|') === deseado.join('|')) return;   // ya está bien

      // Los recomendados van al final del cuerpo: las líneas se insertan
      // delante para no colarse entre ellos.
      var ref = cuerpo.querySelector('[data-cd-recomendados]');
      deseado.forEach(function (k) {
        if (ref) cuerpo.insertBefore(porClave[k], ref);
        else cuerpo.appendChild(porClave[k]);
      });
    }).catch(function () {});
  }

  var tic = null;
  function programar() {
    clearTimeout(tic);
    tic = setTimeout(ordenar, 120);
  }

  if ('MutationObserver' in window) {
    var vigilar = function () {
      if (!document.body) return;
      new MutationObserver(function () {
        if (document.querySelector(CUERPO)) programar();
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) vigilar();
    else document.addEventListener('DOMContentLoaded', vigilar);
  }
  ['cart:refresh', 'cart:updated', 'cart:open', 'cd:open', 'cd:refresh', 'carrito-lateral:actualizado']
    .forEach(function (ev) { document.addEventListener(ev, programar, true); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', programar);
  else programar();
})();
